
import img1 from '@/assets/imgs/casino/keno/icon-risk-low.webp';
import img2 from '@/assets/imgs/casino/keno/icon-risk-medium.webp';
import img3 from '@/assets/imgs/casino/keno/icon-risk-high.webp';


export const aRiskOptions = Object.freeze([{
    label: 'Low',
    value: 'low',
    i18n: 'commonInfo.riskLow', 
    optionIcon: `<img src=${img1} class="w-6 h-6" />`,
}, {
    label: 'Medium',
    value: 'medium',
    i18n: 'commonInfo.riskMedium', 
    optionIcon: `<img src=${img2} class="w-6 h-6" />`,
}, {
    label: 'High',
    value: 'hight',
    i18n: 'commonInfo.riskHigh', 
    optionIcon: `<img src=${img3} class="w-6 h-6" />`,
}]);


